import { Box } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import { Field, useFormikContext } from 'formik';

import { FormSection } from 'common/components/FormSection';
import { Link } from 'common/components/Link';
import { Switch } from 'common/components/FormField';

import { TOrganisationSettingsFormValues } from './OrganisationSettingsForm';

export const UserSettingsForm = () => {
    const [translate] = useTranslation();
    const { values } = useFormikContext<TOrganisationSettingsFormValues>();

    return (
        <FormSection
            description={
                <Box>
                    <Trans
                        components={{
                            a: <Link rel="noreferrer" underline="always" />,
                        }}
                        i18nKey="academySettingsForm.userSettingsDescription"
                    />
                </Box>
            }
            title={translate('academySettingsForm.userSettingsTitle')}
        >
            <Box sx={{ mb: -2 }}>
                <Field
                    checked={values.allowUserEmailChange}
                    component={Switch}
                    label={translate(
                        'academySettingsForm.allowUserEmailChange'
                    )}
                    name="allowUserEmailChange"
                />
            </Box>
        </FormSection>
    );
};
